import React, {Component, Fragment} from 'react';
import {Redirect} from "react-router";
import {withTranslation} from 'react-i18next';
import Moment from "moment";

class ClientLoanList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loans: null,
        };

        this.getClientLoanList();
    }

    getClientLoanList() {
        axios.get('/api/profile/my_loans')
            .then(
                data => {
                    this.setState({loans: data.data.deals});
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    render() {

        if (!this.props.is_logged_in) {
            return (<Redirect push={true} to='/auth/login'/>);
        }

        // Not loaded yet
        if (this.state.loans === null) {
            return null;
        }

        return (
            <div className="container frame p-5">

                <h4>{this.props.t('my_loans')}</h4>

                {this.state.loans.length === 0 &&
                <div>{this.props.t('forms.no_loans_yet')}</div>
                }

                {this.state.loans.length > 0 && (
                    <div className="table-responsive">
                        <table className="table table-bordered mb-0">
                            <thead>
                            <tr>
                                <th scope="col">{this.props.t('forms.loan_list.agreement')}</th>
                                <th className="text-right" scope="col">{this.props.t('forms.loan_list.date')}</th>
                                <th className="text-right" scope="col">{this.props.t('forms.loan_list.amount')}</th>
                                <th className="text-right" scope="col">{this.props.t('forms.loan_list.period')}</th>
                                <th className="text-right"
                                    scope="col">{this.props.t('forms.loan_list.monthly_payment')}</th>
                            </tr>
                            </thead>

                            <tbody>

                            {this.items = this.state.loans.map((loan, key) => {
                                return (
                                    <Fragment key={key}>
                                        <tr className="border-top-0">
                                            <td className="pt-0 text-nowrap">
                                                <p className="text-primary mb-0">{this.props.t('forms.loan_list.small_loan')}</p>
                                            </td>
                                            <td className="pt-0 text-right text-nowrap">{Moment(loan.dl_make_dt).format('YYYY-MM-DD HH:mm')}</td>
                                            <td className="pt-0 text-right text-nowrap">{loan.financed_amount.toFixed(2)} {loan.curr}</td>
                                            <td className="pt-0 text-right text-nowrap">{loan.term} {this.props.t('forms.months_short')}</td>
                                            <td className="pt-0 text-right text-nowrap">{loan.balance.installment_amount.toFixed(2)} {loan.curr}</td>
                                        </tr>
                                        <tr className="border-top-0">
                                            <td className="pt-0 pb-3" colSpan="5">
                                                <div className="w-50 text-left float-left small pt-2">
                                                    {this.props.t('forms.loan_list.agreement_no')}
                                                    &nbsp;<span className="font-weight-bold">{loan.dl_num}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </Fragment>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    };
}

export default withTranslation()(ClientLoanList);
